// extracted by mini-css-extract-plugin
export default {"indicator":"_1grEJRYRT4KEAwtuBI7N4l","seconds":"qNf31acfS_pOQvqBT8GWi"};